"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _gAxios = _interopRequireWildcard(require("@gravity/g-axios"));
var _constant = require("./constant");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1o93x7kz0y() {
  var path = "/codebuild/output/src183882336/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/section/lib/actions.js";
  var hash = "32dc9293beffd1db110894e9a1aa41510e7b90a2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src183882336/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/section/lib/actions.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 23
        },
        end: {
          line: 9,
          column: 2
        }
      },
      "1": {
        start: {
          line: 4,
          column: 61
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "2": {
        start: {
          line: 11,
          column: 28
        },
        end: {
          line: 13,
          column: 2
        }
      },
      "3": {
        start: {
          line: 11,
          column: 35
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "4": {
        start: {
          line: 15,
          column: 29
        },
        end: {
          line: 19,
          column: 2
        }
      },
      "5": {
        start: {
          line: 15,
          column: 48
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "6": {
        start: {
          line: 21,
          column: 27
        },
        end: {
          line: 23,
          column: 2
        }
      },
      "7": {
        start: {
          line: 21,
          column: 34
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "8": {
        start: {
          line: 29,
          column: 13
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "9": {
        start: {
          line: 29,
          column: 31
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "10": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 34
        }
      },
      "11": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 52,
          column: 7
        }
      },
      "12": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 45,
          column: 7
        }
      },
      "13": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 43,
          column: 10
        }
      },
      "14": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 29
        }
      },
      "15": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 21
        }
      },
      "16": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 37
        }
      },
      "17": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 102
        }
      },
      "18": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 23
          },
          end: {
            line: 4,
            column: 24
          }
        },
        loc: {
          start: {
            line: 4,
            column: 61
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 28
          },
          end: {
            line: 11,
            column: 29
          }
        },
        loc: {
          start: {
            line: 11,
            column: 35
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 15,
            column: 29
          },
          end: {
            line: 15,
            column: 30
          }
        },
        loc: {
          start: {
            line: 15,
            column: 48
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 15
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 21,
            column: 27
          },
          end: {
            line: 21,
            column: 28
          }
        },
        loc: {
          start: {
            line: 21,
            column: 34
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 21
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 29,
            column: 14
          }
        },
        loc: {
          start: {
            line: 29,
            column: 31
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 29
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 29,
            column: 31
          },
          end: {
            line: 29,
            column: 32
          }
        },
        loc: {
          start: {
            line: 29,
            column: 43
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 29
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 36,
            column: 10
          },
          end: {
            line: 36,
            column: 11
          }
        },
        loc: {
          start: {
            line: 36,
            column: 22
          },
          end: {
            line: 47,
            column: 5
          }
        },
        line: 36
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 48,
            column: 11
          },
          end: {
            line: 48,
            column: 12
          }
        },
        loc: {
          start: {
            line: 48,
            column: 23
          },
          end: {
            line: 52,
            column: 5
          }
        },
        line: 48
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 37
      },
      "1": {
        loc: {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 37,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 37,
            column: 32
          }
        }, {
          start: {
            line: 37,
            column: 36
          },
          end: {
            line: 37,
            column: 57
          }
        }],
        line: 37
      },
      "2": {
        loc: {
          start: {
            line: 40,
            column: 12
          },
          end: {
            line: 40,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 12
          },
          end: {
            line: 40,
            column: 25
          }
        }, {
          start: {
            line: 40,
            column: 29
          },
          end: {
            line: 40,
            column: 50
          }
        }],
        line: 40
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "32dc9293beffd1db110894e9a1aa41510e7b90a2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1o93x7kz0y = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1o93x7kz0y();
cov_1o93x7kz0y().s[0]++;
var changeLanguage = function changeLanguage(data, language, defaultLanguage) {
  cov_1o93x7kz0y().f[0]++;
  cov_1o93x7kz0y().s[1]++;
  return {
    type: _constant.SectionActionTypes.SECTION_CHANGE_LANGUAGE,
    data: data,
    language: language,
    defaultLanguage: defaultLanguage
  };
};
cov_1o93x7kz0y().s[2]++;
var getBeforeLoadAction = function getBeforeLoadAction() {
  cov_1o93x7kz0y().f[1]++;
  cov_1o93x7kz0y().s[3]++;
  return {
    type: _constant.SectionActionTypes.SECTION_BEFORE_LOAD
  };
};
cov_1o93x7kz0y().s[4]++;
var getLoadSuccessAction = function getLoadSuccessAction(data, config) {
  cov_1o93x7kz0y().f[2]++;
  cov_1o93x7kz0y().s[5]++;
  return {
    type: _constant.SectionActionTypes.SECTION_LOAD_SUCCESS,
    data: data,
    config: config
  };
};
cov_1o93x7kz0y().s[6]++;
var getLoadErrorAction = function getLoadErrorAction() {
  cov_1o93x7kz0y().f[3]++;
  cov_1o93x7kz0y().s[7]++;
  return {
    type: _constant.SectionActionTypes.SECTION_LOAD_ERROR
  };
};

/*
 * The loader get the section data based on the code of the section we want to get
 * To use it : dispatch(sectionActions.load(id));
 */
cov_1o93x7kz0y().s[8]++;
var load = function load(config, code) {
  cov_1o93x7kz0y().f[4]++;
  cov_1o93x7kz0y().s[9]++;
  return function (dispatch) {
    cov_1o93x7kz0y().f[5]++;
    cov_1o93x7kz0y().s[10]++;
    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadAction());
    // then fetch the section
    cov_1o93x7kz0y().s[11]++;
    return (0, _gAxios.default)("".concat(config.restHost, "/v1/sections/").concat(code), {
      headers: config.headers
    }).then(function (response) {
      cov_1o93x7kz0y().f[6]++;
      cov_1o93x7kz0y().s[12]++;
      if ((cov_1o93x7kz0y().b[1][0]++, response.status >= 200) && (cov_1o93x7kz0y().b[1][1]++, response.status < 300)) {
        cov_1o93x7kz0y().b[0][0]++;
        cov_1o93x7kz0y().s[13]++;
        dispatch(getLoadSuccessAction((cov_1o93x7kz0y().b[2][0]++, response.data) && (cov_1o93x7kz0y().b[2][1]++, response.data.section),
        // the server return a { section : {}}
        config));
        cov_1o93x7kz0y().s[14]++;
        return response.data;
      } else {
        cov_1o93x7kz0y().b[0][1]++;
      }
      cov_1o93x7kz0y().s[15]++;
      throw response;
    }).catch(function (response) {
      cov_1o93x7kz0y().f[7]++;
      cov_1o93x7kz0y().s[16]++;
      dispatch(getLoadErrorAction());
      cov_1o93x7kz0y().s[17]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_1o93x7kz0y().s[18]++;
      return response;
    });
  };
};
var _default = exports.default = {
  load: load,
  changeLanguage: changeLanguage
};